import React, { useContext } from 'react';
import { Context } from '../../context/news_search.context';
import Header from '../header/header';
import SortFilter from '../sort_filter/sort_filter';
import AppliedSavedSearch from '../applied_saved_search/applied_saved_search';
import Articles from '../articles/articles';
import Pagination from '../../../components/react/pagination/pagination';
import AlertPopup from '../../../components/react/alert_popup/alert_popup';
import styles from './container.module.scss';

const Container: React.FC = () => {
  const {
    isLoading,
    appliedSavedSearch,
    pageNumber,
    setPageNumber,
    pageTotal,
    alertData,
    setAlertData,
  } = useContext(Context);

  const handlePageSelection = (nextPageNumber: number): void => {
    window.scrollTo({
      top: document.getElementById('results').offsetTop,
      behavior: 'smooth',
    });

    setPageNumber(nextPageNumber);
  };

  return (
    <>
      <AlertPopup alertData={alertData} setAlertData={setAlertData} />
      <div id='results'>
        <fieldset
          aria-label='news search'
          className={`m-0 p-0 ${styles.Fieldset}`}
          disabled={isLoading}
        >
          <Header />
        </fieldset>
        {!!Object.keys(appliedSavedSearch).length && <AppliedSavedSearch />}
        <SortFilter />
        <Articles />
        <Pagination
          currentPage={pageNumber}
          maxPages={pageTotal}
          disabled={isLoading}
          handlePageSelected={handlePageSelection}
        />
      </div>
    </>
  );
};

export default Container;
